import React from 'react';
import JUNOCheckbox from '../../../components/JUNOCheckbox';
import JUNOSwitch from '../../../components/JUNOSwitch';
interface AdminPrefProps {
  id: number;
  pref;
  makeApiRequest;
}

const AdminPref: React.FC<AdminPrefProps> = ({ id, pref, makeApiRequest }) => {
  const { web_push, app_push, email, global_on, title } = pref;
  const globalPushOn = global_on === '1';
  const webPushOn = globalPushOn && web_push === '1';
  const appPushOn = globalPushOn && app_push === '1';
  const emailPushOn = globalPushOn && email === '1';
  const allChecked = webPushOn && appPushOn && emailPushOn;

  return (
    <div className="pref_item">
      <div className="pref_item_title">
        <h4 className={`${globalPushOn ? '' : 'disabled'}`}>
          {title}
          <JUNOCheckbox
            checked={globalPushOn ? allChecked : false}
            name="all"
            text={globalPushOn && allChecked ? 'Deselect All' : 'Select All'}
            value="all"
            stateChange={checked => {
              makeApiRequest({ pref_id: id, overall: checked });
            }}
            disabled={!globalPushOn}
          />
        </h4>
        <JUNOSwitch
          toggle_side={'right'}
          id={Date.now() + 1}
          switch_title="Display in user preferences"
          switch_subtitle=""
          initialState={globalPushOn}
          handleChange={checked => {
            makeApiRequest({ pref_id: id, global_on: checked });
          }}
        />
      </div>
      <div className={`checks_container ${globalPushOn ? '' : 'disabled'}`}>
        <JUNOSwitch
          toggle_side={'left'}
          id={Date.now() + 2}
          switch_title={CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_WEB_PUSH}
          switch_subtitle={webPushOn ? 'On' : 'Off'}
          initialState={webPushOn ? true : false}
          handleChange={checked => {
            makeApiRequest({ pref_id: id, web_push: checked });
          }}
          disabled={!globalPushOn}
        />
        <JUNOSwitch
          toggle_side={'left'}
          id={Date.now() + 3}
          switch_title={CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_APP_PUSH}
          switch_subtitle={appPushOn ? 'On' : 'Off'}
          initialState={appPushOn ? true : false}
          handleChange={checked => {
            makeApiRequest({ pref_id: id, app_push: checked });
          }}
          disabled={!globalPushOn}
        />
        <JUNOSwitch
          toggle_side={'left'}
          id={Date.now() + 4}
          switch_title={CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_EMAIL_PUSH}
          switch_subtitle={emailPushOn ? 'On' : 'Off'}
          initialState={emailPushOn ? true : false}
          handleChange={checked => {
            makeApiRequest({ pref_id: id, email: checked });
          }}
          disabled={!globalPushOn}
        />
      </div>
    </div>
  );
};
export default AdminPref;
